const integerFormatter = new Intl.NumberFormat('en-GB', {
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Locale-aware integer/count formatting (e.g. 16249 → 16,249). */
export function formatNumber(
  value: number,
  options?: { maximumFractionDigits?: number }
): string {
  if (!Number.isFinite(value)) return '—';
  if (options?.maximumFractionDigits != null && options.maximumFractionDigits > 0) {
    return new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: options.maximumFractionDigits,
    }).format(value);
  }
  return integerFormatter.format(value);
}

/** Compact decimal formatting for weights, averages, etc. */
export function formatDecimal(value: number, maximumFractionDigits = 2): string {
  if (!Number.isFinite(value)) return '—';
  return decimalFormatter.format(value);
}

/** Summary cards: format plain numbers; leave pre-formatted strings unchanged. */
export function formatDisplayValue(value: string | number): string {
  if (typeof value === 'number') {
    return formatNumber(value);
  }
  return value;
}
